import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="50" viewBox="0 0 66 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_14)">
      <path d="M0 0H66V49.9459H0V0Z" fill="#C8102E" />
      <path d="M0 21.4054H21.4054V0H28.5405V21.4054H66V28.5405H28.5405V49.9459H21.4054V28.5405H0V21.4054Z" fill="white" />
      <path d="M66 0H0V49.7538H66V0Z" stroke="#9F9D9D" />
    </g>
    <defs>
      <clipPath id="clip0_1_14">
        <rect width="66" height="49.9459" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
